import { api } from './api';

export interface League {
  id: string;
  name: string;
  division?: string;
  region?: string;
  description?: string;
  logoUrl?: string;
  logoPath?: string;
  website?: string;
  createdByParentId?: string;

  // Global league fields
  isGlobalLeague?: boolean;
  globalScheduleId?: string;

  // Playoff configuration
  playoffsEnabled?: boolean;
  playoffSpots?: number;
  standingsSortBy?: string;
  standingsSource?: 'calculated' | 'imported';

  // Legacy platform fields (deprecated)
  platformType?: 'GOTSPORT' | 'SINCSPORTS' | 'MANUAL';
  platformLeagueId?: string;
  platformUrl?: string;

  // Season completion
  seasonCompleted?: boolean;
  seasonCompletedAt?: string;

  // Schedule import status
  lastScheduleImport?: string;
  scheduleImportStatus?: 'idle' | 'importing' | 'success' | 'error';
  scheduleImportFrequency?: 'manual' | 'daily' | 'weekly' | 'hourly';

  teams?: Team[];
  createdAt: string;
  updatedAt: string;
}

export interface Team {
  id: string;
  name: string;
  division?: string;
  club?: string;
  leagueId: string;
  platformTeamId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateLeagueRequest {
  name: string;
  division?: string;
  region?: string;
  description?: string;
  logoUrl?: string;
  website?: string;
  platformType?: 'GOTSPORT' | 'SINCSPORTS' | 'MANUAL';
  platformLeagueId?: string;
  platformUrl?: string;
}

export interface UpdateLeagueRequest {
  name?: string;
  division?: string;
  region?: string;
  description?: string;
  logoUrl?: string;
}

export const leagueService = {
  // Get all leagues
  async getLeagues(page: number = 1, limit: number = 20): Promise<{ data: League[]; pagination: any }> {
    const response = await api.get(`/leagues?page=${page}&limit=${limit}`);
    return response.data;
  },

  // Search leagues by name
  async searchLeagues(query: string): Promise<League[]> {
    const response = await api.get(`/leagues?q=${encodeURIComponent(query)}`);
    return response.data.data || response.data; // Handle both paginated and non-paginated responses
  },

  // Get league by ID
  async getLeague(id: string): Promise<League> {
    const response = await api.get(`/leagues/${id}`);
    return response.data;
  },

  // Get teams for a league
  async getLeagueTeams(leagueId: string): Promise<Team[]> {
    const response = await api.get(`/leagues/${leagueId}/teams`);
    return response.data;
  },

  // Create league
  async createLeague(data: CreateLeagueRequest): Promise<League> {
    const response = await api.post('/leagues', data);
    return response.data;
  },

  // Update league
  async updateLeague(id: string, data: UpdateLeagueRequest): Promise<League> {
    const response = await api.put(`/leagues/${id}`, data);
    return response.data;
  },

  // Delete league
  async deleteLeague(id: string): Promise<void> {
    await api.delete(`/leagues/${id}`);
  },



  // Assign player to league
  async assignPlayerToLeague(leagueId: string, playerId: string, data: any): Promise<any> {
    const response = await api.put(`/leagues/${leagueId}/players/${playerId}`, data);
    return response.data;
  },

  // Remove player from league
  async removePlayerFromLeague(leagueId: string, playerId: string): Promise<void> {
    await api.delete(`/leagues/${leagueId}/players/${playerId}`);
  },



  // Schedule Import API endpoints (new league-centric approach)
  


};
